import { useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { inr } from "../lib/api";

const Line = ({ it }) => {
  const { setQty } = useCart();
  const id = `${it.slug}-${it.size}`;
  return (
    <div className="flex gap-4 border-b border-white/10 py-4" data-testid={`cart-item-${id}`}>
      <img src={it.image} alt={it.name} className="h-24 w-20 object-cover" />
      <div className="flex flex-1 flex-col">
        <div className="flex justify-between gap-2">
          <p className="font-display text-xl font-extrabold uppercase leading-none">{it.name}</p>
          <button data-testid={`cart-remove-${id}`} onClick={() => setQty(it.slug, it.size, 0)} className="text-zinc-400 hover:text-[#FF2A55]"><X className="h-4 w-4" /></button>
        </div>
        <p className="mt-1 font-mono text-xs uppercase text-zinc-400">Size {it.size} · {it.color}</p>
        <div className="mt-auto flex items-center justify-between">
          <div className="flex items-center border border-white/15">
            <button data-testid={`cart-dec-${id}`} onClick={() => setQty(it.slug, it.size, it.qty - 1)} className="p-2 hover:text-[#00FF66]"><Minus className="h-3 w-3" /></button>
            <span className="w-8 text-center font-mono text-sm" data-testid={`cart-qty-${id}`}>{it.qty}</span>
            <button data-testid={`cart-inc-${id}`} onClick={() => setQty(it.slug, it.size, it.qty + 1)} className="p-2 hover:text-[#00FF66]"><Plus className="h-3 w-3" /></button>
          </div>
          <p className="font-mono text-sm font-bold">{inr(it.price * it.qty)}</p>
        </div>
      </div>
    </div>
  );
};

export const CartDrawer = () => {
  const { items, open, setOpen, subtotal } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="flex w-full flex-col border-white/10 bg-[#0A0A0B] p-0 sm:max-w-md">
        <div className="border-b border-white/10 p-6">
          <SheetTitle className="font-display text-4xl font-black uppercase">Your Bag</SheetTitle>
          <SheetDescription className="font-mono text-xs uppercase tracking-widest text-zinc-400">Free shipping across India</SheetDescription>
        </div>
        <div className="flex-1 overflow-y-auto px-6" data-lenis-prevent>
          {items.length === 0 ? (
            <p className="py-16 text-center font-mono text-sm uppercase text-zinc-400" data-testid="cart-empty">Bag is empty. Go loud.</p>
          ) : items.map((it) => <Line key={`${it.slug}-${it.size}`} it={it} />)}
        </div>
        <div className="border-t border-white/10 p-6">
          <div className="mb-4 flex justify-between font-mono text-sm uppercase">
            <span className="text-zinc-400">Subtotal</span>
            <span className="font-bold" data-testid="cart-subtotal">{inr(subtotal)}</span>
          </div>
          <button
            data-testid="proceed-checkout-btn"
            disabled={!items.length}
            onClick={() => { setOpen(false); nav("/checkout"); }}
            className="w-full bg-[#00FF66] py-4 font-display text-2xl font-black uppercase text-black transition-colors hover:bg-white disabled:opacity-40"
          >
            Checkout →
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
